(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('ProdutoModalService', ProdutoModalServiceFactory);

  ProdutoModalServiceFactory.$inject = [
    '$uibModal',
    '$q'
  ];

  // eslint-disable-next-line max-lines-per-function
  function ProdutoModalServiceFactory($uibModal, $q) {
    const service = {
      open,
      findProductSelected,
      findSelected,
      mergeProducts,
      buildModalList
    };
    return service;

    //////////////////////////////////////////
    // Function declarations

    function open(products, preSelected, options = {}) {
      const { allowMultiple = true, fetchProducts = null } = options;
      const modal = $uibModal.open({
        controller: 'ProdutoModalCtrl',
        controllerAs: 'ctrl',
        resolve: {
          products: () => products,
          preSelected: () => preSelected,
          allowMultiple: () => allowMultiple,
          fetchProducts: () => fetchProducts
        },
        templateUrl: 'views/_produto-modal.html'
      });

      return modal.result;
    }

    function findSelected(list, selected) {
      return (selected || []).map((prod) => _.find(list, {
        id: prod.item_id || prod.item_codigo || prod.id || prod.cd_item
      }));
    }

    function isSameProduct(curr, sel) {
      return curr.item_codigo === sel.id ||
      curr.item_id === sel.id ||
      curr.cd_item === sel.id ||
      curr.id === sel.id;
    }

    function findProductSelected(list, selected) {
      return (selected || []).map((prod) => {
        let productId;
        if ('produto' in prod) {
          productId = prod.produto.item_id;
        } else {
          productId = prod.item_id || prod.item_codigo || prod.id || prod.cd_item;
        }
        return _.find(list, {
          id: productId
        });
      });
    }

    function buildModalList(initialList, currentProducts, fetchByIds) {
      const listIds = new Set((initialList || []).map(function(p) {
        return p.id;
      }));
      const missingIds = (currentProducts || [])
        .map(function(p) {
          return p.item_id || p.item_codigo || p.id || p.cd_item;
        })
        .filter(function(id) {
          return id && !listIds.has(id);
        });

      if (!missingIds.length) {
        return $q.resolve(initialList || []);
      }

      return fetchByIds(missingIds)
        .then(function(missingItems) {
          return (missingItems || []).concat(initialList || []);
        })
        .catch(function() {
          return initialList || [];
        });
    }

    function mergeProducts(selection, current) {
      return $q((resolve) => {
        if (current && current.length) {
          const remainingSelection = selection.filter((sel) => !current.find((curr) => isSameProduct(curr, sel)));

          const remainingCurrent = current.filter((curr) => selection.find((sel) => isSameProduct(curr, sel)));

          current.length = 0;
          current.push(...remainingCurrent);

          resolve(remainingSelection);
        } else {
          resolve(selection);
        }
      });
    }
  }
}());
